module.exports = __webpack_public_path__ + "img/linkedIn.f08c524d.png";